import { get, remove, set } from 'lib/storage/isomorphicSessionStorage'
import type { CreateGhaVoucherInput } from 'actions/MetasearchVoucherActions'

const PENDING_GHA_VOUCHER_SESSION_KEY = 'pendingGhaVoucher'

export interface PendingGhaVoucher extends CreateGhaVoucherInput {
  /**
   * The rate total the offer page priced against. Checkout resolves the discount preview
   * from this rather than its own total, which the preview itself would then change.
   */
  price: number
}

function isCompletePendingGhaVoucher(input: PendingGhaVoucher | undefined): input is PendingGhaVoucher {
  return !!(
    input?.token &&
    input.propertyId &&
    input.checkIn &&
    input.checkOut &&
    input.rooms?.length
  )
}

/**
 * Voucher inputs the offer page resolved but could not use yet, because a GHA voucher is
 * assigned to a customer as it is created and nobody is signed in until checkout.
 *
 * `token` and `rateRuleId` come from the landing URL, which `/checkout` does not carry.
 * Session storage rather than checkout state so it survives a mid-checkout refresh.
 */
export function setPendingGhaVoucher(input: PendingGhaVoucher) {
  set(PENDING_GHA_VOUCHER_SESSION_KEY, input)
}

export function getPendingGhaVoucher(): PendingGhaVoucher | undefined {
  const pendingVoucher = (get(PENDING_GHA_VOUCHER_SESSION_KEY) ?? undefined) as PendingGhaVoucher | undefined
  if (!isCompletePendingGhaVoucher(pendingVoucher)) {
    remove(PENDING_GHA_VOUCHER_SESSION_KEY)
    return undefined
  }
  return pendingVoucher
}

export function clearPendingGhaVoucher() {
  remove(PENDING_GHA_VOUCHER_SESSION_KEY)
}
